import { PAYMENT_METHOD, PAP_MESSAGE_TYPE } from './constants'

const getPaymentMethodInfo = (cart) => {
  const mobPaymentMethod = cart.root?.customer?.mobility?.currentPaymentMethod
  const hsPaymentMethod = cart.root?.customer?.hs?.currentPaymentMethod
  return {
    mobPaymentMethod,
    hsPaymentMethod,
    isNewCustomer: mobPaymentMethod === undefined && hsPaymentMethod === undefined
  }
}

const getPAPEligibleItems = (cart) => {
  return Object.values(cart.items || []).filter((item) => {
    return item.system?.papDiscountIndicator === true
  })
}

const getIsMobPAPEligible = (items) => {
  return items.filter((item) => item.category === 'MOBILITY_PLAN').length > 0
}

const getIsHSPAPEligible = (items) => {
  return items.filter((item) => item.category === 'HS_OFFER').length > 0
}

export const getTotalPAPDiscount = (cart) => {
  const items = getPAPEligibleItems(cart)
  const totalDiscount = items.reduce(
    (acc, curr) => {
      const { padDiscountAmount, pacDiscountAmount } = acc
      return {
        padDiscountAmount: padDiscountAmount + (curr.system.padDiscountAmount || 0),
        pacDiscountAmount: pacDiscountAmount + (curr.system.pacDiscountAmount || 0)
      }
    },
    {
      padDiscountAmount: 0,
      pacDiscountAmount: 0
    }
  )
  return totalDiscount
}

export const getPAPMessage = (cart) => {
  const items = getPAPEligibleItems(cart)
  const { mobPaymentMethod, hsPaymentMethod, isNewCustomer } = getPaymentMethodInfo(cart)
  const isMobPAPEligible = getIsMobPAPEligible(items)
  const isHSPAPEligible = getIsHSPAPEligible(items)
  const { padDiscountAmount, pacDiscountAmount } = getTotalPAPDiscount(cart)
  const isSBS = padDiscountAmount === pacDiscountAmount

  const getMessageForNewCustomer = () => {
    if (isMobPAPEligible && isHSPAPEligible)
      return isSBS
        ? PAP_MESSAGE_TYPE.PAP_PROMOTING_NEW_CUSTOMER_BUYING_MNH
        : PAP_MESSAGE_TYPE.PAD_PROMOTING_NEW_CUSTOMER_BUYING_MNH
    if (isMobPAPEligible)
      return isSBS
        ? PAP_MESSAGE_TYPE.PAP_PROMOTING_NEW_CUSTOMER_BUYING_MOBILITY
        : PAP_MESSAGE_TYPE.PAD_PROMOTING_NEW_CUSTOMER_BUYING_MOBILITY
    if (isHSPAPEligible)
      return isSBS
        ? PAP_MESSAGE_TYPE.PAP_PROMOTING_NEW_CUSTOMER_BUYING_HS
        : PAP_MESSAGE_TYPE.PAD_PROMOTING_NEW_CUSTOMER_BUYING_HS
  }

  const getMessageForExistingCustomer = () => {
    if ((isHSPAPEligible && !hsPaymentMethod) || (isMobPAPEligible && !mobPaymentMethod))
      return isSBS
        ? PAP_MESSAGE_TYPE.PAP_PROMOTING_EXISTING_CUSTOMER_BUYING_CROSSLINE
        : PAP_MESSAGE_TYPE.PAD_PROMOTING_EXISTING_CUSTOMER_BUYING_CROSSLINE
    if (
      (isHSPAPEligible && hsPaymentMethod === PAYMENT_METHOD.REGULAR) ||
      (isMobPAPEligible && mobPaymentMethod === PAYMENT_METHOD.REGULAR)
    )
      return isSBS
        ? PAP_MESSAGE_TYPE.PAP_PROMOTING_EXISTING_CUSTOMER_WITHOUT_PAP
        : PAP_MESSAGE_TYPE.PAD_PROMOTING_EXISTING_CUSTOMER_WITHOUT_PAP
    if (
      (isHSPAPEligible && hsPaymentMethod === PAYMENT_METHOD.PAD) ||
      (isMobPAPEligible && mobPaymentMethod === PAYMENT_METHOD.PAD)
    )
      return isSBS
        ? PAP_MESSAGE_TYPE.PAP_PROMOTING_EXISTING_CUSTOMER_WITH_PAD
        : PAP_MESSAGE_TYPE.PAD_PROMOTING_EXISTING_CUSTOMER_WITH_PAD
    if (
      (isHSPAPEligible && hsPaymentMethod === PAYMENT_METHOD.PAC) ||
      (isMobPAPEligible && mobPaymentMethod === PAYMENT_METHOD.PAC)
    )
      return isSBS
        ? PAP_MESSAGE_TYPE.PAP_PROMOTING_EXISTING_CUSTOMER_WITH_PAC
        : PAP_MESSAGE_TYPE.PAD_PROMOTING_EXISTING_CUSTOMER_WITH_PAC
  }

  if (isNewCustomer) {
    const message = getMessageForNewCustomer()
    if (message) return message
  } else {
    const message = getMessageForExistingCustomer()
    if (message) return message
  }
  return undefined
}
